import { render, staticRenderFns } from "./Purpose.vue?vue&type=template&id=d010681a&scoped=true"
import script from "./Purpose.vue?vue&type=script&lang=js"
export * from "./Purpose.vue?vue&type=script&lang=js"
import style0 from "./Purpose.vue?vue&type=style&index=0&id=d010681a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d010681a",
  null
  
)

export default component.exports